module.exports = __webpack_public_path__ + "static/media/dots.88409db5.svg";